import React from 'react';
import Layout from "../../components/layout/Layout";
import WorkshopManagement from "../../components/workshops/WorkshopManagement";
const ManageWorkshopsPage = () => {
    return (
      <Layout>
        <main className="admin-background">
          <WorkshopManagement />
        </main>
      </Layout>
    );
  }

  export default (ManageWorkshopsPage);